import React from 'react';
import { useOrderProductionEmployeeInputQuery } from '../../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../../dum';
import { ID, IOrderProduction } from '../../order-production-form';
import { useFormContext, useWatch } from 'react-hook-form';
import { useOrderProductionNamePrefix } from '../../order-production-name-prefix.context';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

const ARRAY_NAME: keyof IOrderProduction = 'order_production_employees';
const EMPLOYEE_FIELD_NAME: keyof IOrderProduction['order_production_employees'][number] =
    'employee';

const IS_LEADER: keyof IOrderProduction['order_production_employees'][number] =
    'is_leader';

interface IProductsInput {
    index: number;
}

export function OrderProductionProductInput({ index }: IProductsInput) {
    const prefix = useOrderProductionNamePrefix();
    const PREFIXED_ARRAY = `${prefix}${ARRAY_NAME}`;

    const id: IOrderProduction['id'] = useWatch({
        name: ID,
    });

    const { data: employeeData } = useOrderProductionEmployeeInputQuery({
        variables: {
            excludeDiscontinued: !id,
        },
    });
    const INPUT_NAME = `${PREFIXED_ARRAY}.${index}.${EMPLOYEE_FIELD_NAME}`;
    const formContext = useFormContext();

    const employees = employeeData?.getEmployees || [];

    return (
        <RhSingleAutocomplete
            itemText={'fullname'}
            itemValue={'id'}
            returnObject
            options={employees}
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.employee_id)}
            disableGutters
            onChange={(val) => {
                const orderProductionEmployees = formContext.getValues(
                    PREFIXED_ARRAY,
                ) as IOrderProduction['order_production_employees'];
                orderProductionEmployees.forEach((e, i) => {
                    void formContext.trigger(
                        `${PREFIXED_ARRAY}.${i}.${EMPLOYEE_FIELD_NAME}`,
                    );
                });

                formContext.setValue(
                    `${PREFIXED_ARRAY}.${index}.${IS_LEADER}`,
                    val.is_leader === 1,
                );
            }}
        />
    );
}
